export default __webpack_public_path__ + "static/media/5.aba350a4.jpg";